import {LeadResources} from '../resources/lead.resources';
import {Auth} from '@firebase/auth';
import {Lead} from '../data/domain/lead';
import {DateTime} from 'luxon';
import {jwtToken} from './jwt';

export const createOrUpdateLead = async (sessionId: string, leadResources: LeadResources, auth: Auth) => {
  let leadDTO = leadResources.currentLead.value()
  if (!leadDTO) {
    leadDTO = new Lead()
    leadDTO.sessionId = sessionId
    leadDTO.createdAt = DateTime.now().toMillis();
  }
  if (auth.currentUser && !leadDTO.firstname && !leadDTO.age) {
    const tokenClaims = await jwtToken(auth.currentUser)
    if (auth.currentUser.phoneNumber) {
      leadDTO.phone = auth.currentUser.phoneNumber
      leadDTO.firstname = tokenClaims.firstname ?? leadDTO.firstname
      leadDTO.email = tokenClaims.email ?? leadDTO.email
    }
  }
  return leadDTO
}
